import {Grid, Theme, Typography} from '@material-ui/core'
import React                     from 'react'
import theme                     from '../theme'
import BarristerCard             from './BarristerCard'
import {makeStyles}              from '@material-ui/core/styles'
import {Barrister}               from '../../entities/barrister'

/***
 * Component containing a list of barristers rendered using a `Card` component
 * @param barristers - derived from GraphQL, see `Index` component for GraphQL query
 */

type BarristerListDisplayMode = 'profile-inline' | 'cards-only'

interface BarristersProps {
    barristers: any[]
    displayMode: BarristerListDisplayMode
    placeholderImage?: any
    groupHeading?: string
}

const useStyles = makeStyles((theme: Theme) => ({

    pageTitle: {
        position: 'relative',
        color: '#FFF',
        fontWeight: 500,
        margin: '0.5em 0 0.7em',
        textAlign: 'left',
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
        }
    },
    pageTitleWrapper: {
        width: '100%'
    },
    barristerGrid: {
        [theme.breakpoints.down('xl')]: {
            maxWidth: '1585px'
        },
        [theme.breakpoints.down('lg')]: {
            maxWidth: '1260px'
        },
        [theme.breakpoints.down('md')]: {
            maxWidth: '939px'
        },
        [theme.breakpoints.down('sm')]: {
            maxWidth: '624px'
        },
        [theme.breakpoints.down('xs')]: {
            maxWidth: '305px'
        }
        /*
                flexDirection: 'row',
                flexWrap: 'wrap',
                height: 'auto',
                justifyContent: 'flex-start',
                width: 'auto'
        */
    },
    barristerCard: {
        flex: '0 1 300px'
        // marginBottom: '1em'
    }
}))

const BarristerList = (props: BarristersProps) => {

    const classes = useStyles(theme)
    const {barristers, placeholderImage} = props

    const renderCards = (barristers: Barrister[], groupName?: string, placeholderImage?: any) => (
        <Grid container justify={'center'}>
            <Grid item className={classes.barristerGrid} container spacing={2} justify={'center'}>
                {
                    groupName && (
                        <section className={classes.pageTitleWrapper}>
                            <Typography className={classes.pageTitle} variant={'h2'} component={'h2'}>
                                {groupName}
                            </Typography>
                        </section>
                    )
                }
                {
                    barristers && barristers.map((barrister, index) => (
                            <Grid item key={index}>
                                {
                                    barrister && (
                                        <BarristerCard barrister={barrister}
                                                       placeholderImage={placeholderImage}/>
                                    )
                                }

                            </Grid>
                        )
                    )
                }
            </Grid>
        </Grid>
    )

    return <>
        {barristers ? renderCards(barristers, '', placeholderImage) : null}
    </>

}

export default BarristerList
